module.exports = __webpack_public_path__ + "static/menu_help-622a758bd4c402ea2b582ebf1d4318ce.png";